import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import SpiderChartComponent from '@Components/Results/utils/spider-chart.component';
import { Card } from '@els/els-react--card';

import './substance-druglikeness.component.scss';

export default class SubstanceDruglikenessComponent extends React.PureComponent {
  render() {
    const {
      drugData,
      drugData: { graph },
    } = this.props;
    const listOfValues = graph ? graph.data.reduce((memo, { data }) => memo.concat(data), []) : [];
    const calcScale = listOfValues.length ? Math.ceil(Math.max(...listOfValues) / 10) : 1;
    const tableClassName = 'substance-druglikeness__table c-els-table';

    return (
      <div className="rx-element--druglikeness-data substance-druglikeness">
        <div className="substance-druglikeness__rules">
          {drugData.tableData
            ? drugData.tableData.map((item, index) => (
                <Card
                  className="substance-druglikeness__rule-card"
                  heading={<h4 className="substance-druglikeness__rule-card-title">{item.title}</h4>}
                  headingLevel="h4"
                  key={item.title || index}>
                  <div className="substance-druglikeness__table-wrap">
                    <table className={tableClassName}>
                      <caption className="c-els-table__caption u-els-hide-visually">{item.title}</caption>
                      <colgroup>
                        <col className="substance-druglikeness__label-col" />
                        <col className="substance-druglikeness__value-col" />
                      </colgroup>
                      <tbody className="table__body c-els-table__body">
                        {item.children
                          ? item.children.map((child, childIndex) => (
                              <tr className="table__row c-els-table__row" key={child.id || childIndex}>
                                <InnerHTML
                                  className="table__cell c-els-table__cell c-els-table__basic-cell substance-druglikeness__label-cell"
                                  tag="th"
                                  scope="row"
                                  html={child.title}
                                />
                                <InnerHTML
                                  className="table__cell c-els-table__cell c-els-table__basic-cell substance-druglikeness__value-cell"
                                  tag="td"
                                  html={child.value}
                                />
                              </tr>
                            ))
                          : null}
                      </tbody>
                    </table>
                  </div>
                </Card>
              ))
            : null}
        </div>
        {graph && (
          <SpiderChartComponent
            className="substance-druglikeness__chart"
            categories={graph.labels}
            series={graph.data}
            tickInterval={calcScale}
          />
        )}
      </div>
    );
  }
}

SubstanceDruglikenessComponent.propTypes = {
  drugData: PropTypes.object.isRequired,
};
